import { Box, Flex, Text } from "@chakra-ui/react";
import { customerDashboardStyles } from "theme/overrides/customer";

interface DashboardMetricsProps {
  dashboardTile: any;
}

export const DashboardMetrics: React.FC<DashboardMetricsProps> = ({
  dashboardTile,
}) => {
  return (
    <Flex gap="22px" mb="24px" flexWrap="wrap">
      <Box
        flex="1 1 200px"
        bg={customerDashboardStyles.metricCard.bg}
        borderRadius={customerDashboardStyles.metricCard.borderRadius}
        p="16px"
        textAlign="center"
        border="1px solid #E6ECF3"
      >
        <Text
          fontSize="14px"
          fontWeight="600"
          lineHeight="21px"
          color="#000000"
          mb="7px"
        >
          Active order(s)
        </Text>
        <Text
          fontSize="24px"
          fontWeight="600"
          lineHeight="29px"
          color={customerDashboardStyles.stats.valueColor}
        >
          {dashboardTile?.activeOrders ?? 0}
        </Text>
      </Box>
      <Box
        flex="1 1 200px"
        bg={customerDashboardStyles.metricCard.bg}
        borderRadius={customerDashboardStyles.metricCard.borderRadius}
        p="16px"
        textAlign="center"
        border="1px solid #E6ECF3"
      >
        <Text
          fontSize="14px"
          fontWeight="600"
          lineHeight="21px"
          color="#000000"
          mb="7px"
        >
          Total orders
        </Text>
        <Text
          fontSize="24px"
          fontWeight="600"
          lineHeight="29px"
          color={customerDashboardStyles.stats.valueColor}
        >
          {dashboardTile?.totalOrders ?? 0}
        </Text>
      </Box>
    </Flex>
  );
};
